/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WsAuthenticate
 */
export interface WsAuthenticate {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsAuthenticate
     */
    type?: string | null;
    /**
     * Access Token
     * @type {string}
     * @memberof WsAuthenticate
     */
    token?: string | null;
}

/**
 * Check if a given object implements the WsAuthenticate interface.
 */
export function instanceOfWsAuthenticate(value: object): value is WsAuthenticate {
    return true;
}

export function WsAuthenticateFromJSON(json: any): WsAuthenticate {
    return WsAuthenticateFromJSONTyped(json, false);
}

export function WsAuthenticateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsAuthenticate {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'token': json['token'] == null ? undefined : json['token'],
    };
}

export function WsAuthenticateToJSON(json: any): WsAuthenticate {
    return WsAuthenticateToJSONTyped(json, false);
}

export function WsAuthenticateToJSONTyped(value?: WsAuthenticate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'token': value['token'],
    };
}

